/**
 * Enum para identificar `key` registradas en el localStorage 
*/
export enum Storage {
    /**
     * Token
    */
    Token = 'token',
    /**
     * Response Registro Flow
    */
    ResponseRegistroFlow = 'ResponseRegistroFlow',
    /**
     * Form Registro
    */
    FormRegistro = 'formRegistro',
    /**
     * Recepcion Data
    */
    RecepcionData = 'recepcionData',

    UsuarioData = 'user_data',
    /**
     * Recepcion Form Values
    */
    RecepcionFormValues = 'recepcionFormValues',
    /**
     * Data a tener en cuenta para saber si se puede mostrar el step de fijacion
    */
    RecepcionFijaAudiencia = 'recepcionFijaAudiencia',
    
    /** Campo a tener en cuenta para saber si se mostrara el tour guiado */
    TOUR_GUIADO = 'tourGuiado',
}

/**
 * Claves para localStorage
 */
export enum StorageKeys {
  /** Token de acceso */
  ACCESS_TOKEN = 'access_token',
  
  /** Token de actualización */
  REFRESH_TOKEN = 'refresh_token',
  
  /** Fecha de expiración */
  EXPIRES_AT = 'expires_at',
  
  /** Datos del usuario */
  USER_DATA = 'user_data',
  
  /** Perfil seleccionado del usuario */
  PERFIL = 'perfil',
  
  /** Datos de recepción */
  RECEPCION_DATA = 'recepcionData',
  
  /** Datos del formulario de registro ?? registrar que ?? */
  FORM_REGISTRO = 'formRegistro',
  
  /** Recepcion Form Values */
  RECEPCION_FORM_VALUES = 'recepcionFormValues',
  ALGUACIL = 'queryAlguacil',
  
  /** Data a tener en cuenta para saber si se puede mostrar el step de fijacion */
  RECEPCION_FIJA_AUDIENCIA = 'recepcionFijaAudiencia',
  
  /** Campo a tener en cuenta para saber si se mostrara el tour guiado */
  TOUR_GUIADO = 'tourGuiado',
  /**
   * Response Registro Flow
  */
  RESPONSE_REGISTRO_FLOW = 'responseRegistroFlow',
}
